import { customFetch as fetch } from '../fetch';
import { CostCentre } from './databaseModels';

export const loadCostCentres = async (companyId?: string) => {
    const response = await fetch(`/CostCentre/All${(!!companyId ? `/${companyId}` : '')}`);
    const costCentres: CostCentre[] = response.data.map((cc: any) => new CostCentre(cc.id, cc.name, cc.companyId));

    return costCentres;
};
